<template>
  <div class="relative aspect-[1.333/1] overflow-hidden rounded-xl shadow-sm">
    <div class="relative size-full">
      <img
        :src="image"
        alt=""
        class="size-full object-cover"
      >
      <div class="absolute inset-0 size-full bg-gradient-to-t from-black/80 to-transparent" />
    </div>
    <div class="px-base absolute bottom-0 w-full py-2.5">
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  image: string;
}>();
</script>
